import { render } from "./ObjectiveContent.vue?vue&type=template&id=2494941e&scoped=true"
import script from "./ObjectiveContent.vue?vue&type=script&lang=js"
export * from "./ObjectiveContent.vue?vue&type=script&lang=js"

import "./ObjectiveContent.vue?vue&type=style&index=0&id=2494941e&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2494941e"]])

export default __exports__